/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drab_Quaint_Okapi_EmpowerInputs */

const en_drab_quaint_okapi_empower = /** @type {(inputs: Drab_Quaint_Okapi_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Language`)
};

const de_drab_quaint_okapi_empower = /** @type {(inputs: Drab_Quaint_Okapi_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache auswählen`)
};

/**
* | output |
* | --- |
* | "Change Language" |
*
* @param {Drab_Quaint_Okapi_EmpowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const drab_quaint_okapi_empower = /** @type {((inputs?: Drab_Quaint_Okapi_EmpowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drab_Quaint_Okapi_EmpowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drab_quaint_okapi_empower(inputs)
	return de_drab_quaint_okapi_empower(inputs)
});